export const LANGUAGES_MAP: Record<string, { title: string }> = {
  javascript: { title: 'JavaScript' },
  html: { title: 'HTML' },
  php: { title: 'PHP' },
  java: { title: 'JAVA' },
  csharp: { title: 'C#' },
  cpp: { title: 'C++' },
  xml: { title: 'XML' },
  python: { title: 'Python' },
  yaml: { title: 'YAML' },
  plaintext: { title: 'Plain Text' },
  dockerfile: { title: 'Docker' },
  bat: { title: 'Bash' },
  css: { title: 'CSS' },
  mysql: { title: 'SQL' },
  go: { title: 'GO' },
  json: { title: 'JSON' },
  kotlin: { title: 'Kotlin' },
  swift: { title: 'Swift' },
  typescript: { title: 'TypeScript' },
};
